// Style imports.
import "normalize.css";
import "../../css/main.css";

// React imports.
import React from "react";
import ReactDOM from "react-dom/client";

// App imports.
import BaseLayout from "./components/BaseLayout";
import * as utility from "./utility";
import { IField } from "./utility";
import * as worker from "../baseWorker";
import { IFiscalYear } from "../baseWorker";

const baseComponentRef = React.createRef<BaseLayout>();
const root = ReactDOM.createRoot(document.getElementById("app"));
root.render(
  <BaseLayout ref={baseComponentRef} />
);

// React 18+: createRoot renders asynchronously. Poll for the ref to be populated
// before bootstrapping (a single setTimeout(0) can fire before commit).
function waitForMount(attempt = 0) {
  if (!baseComponentRef.current) {
    if (attempt > 50) {
      console.error("BaseLayout component not mounted yet");
      return;
    }
    setTimeout(() => waitForMount(attempt + 1), 20);
    return;
  }
  const baseComponent = baseComponentRef.current!;

  //display the wait message
  baseComponent.state.showSpinner();
  sessionStorage.clear();

  //get the current user info
  async function getUserInfo() {
    const userWorker: worker.baseWorker = new worker.baseWorker();
    try {

      const currentUser: worker.IUserInfo = await userWorker.getUserInfo();
      baseComponent.state.setCurrentUserInfo(currentUser);
    }
    catch (err) {
      console.log(err);
      baseComponent.state.showError(err.message);
      throw Error("Failed to get user info.");
    }
  }
  //get grantees
  async function getGrantees() {
    const granteeWorker: worker.baseWorker = new worker.baseWorker();
    try {

      const grantees: worker.IGrantee[] = await granteeWorker.getGrantees();
      baseComponent.state.setGrantees(grantees);
    }
    catch (err) {
      console.log(err);
      baseComponent.state.showError(err.message);
      throw Error("Failed to get grant recipients.");
    }
  }
  //get data categories
  async function getFieldCategories() {
    const categoryWorker: utility.ReportWorker = new utility.ReportWorker();
    try {

      const fieldCategories: utility.IField[] = await categoryWorker.getFieldSubCategories();
      baseComponent.state.setFieldSubCategories(fieldCategories);
    }
    catch (err) {
      console.log(err);
      baseComponent.state.showError(err.message);
      throw Error("Failed to get assessments.");
    }
  }
  //get fiscal years
  async function getFiscalYears() {
    const fiscalYearWorker: worker.baseWorker = new worker.baseWorker();
    try {
      //we get an array of FiscalYears
      const fiscalYears: worker.IFiscalYear[] = await fiscalYearWorker.getFiscalYears();
      baseComponent.state.setFiscalYears(fiscalYears);
    }
    catch (err) {
      console.log(err);
      baseComponent.state.showError(err.message);
      throw Error("Failed to get Fiscal Years.");
    }
  }

  const yearsPromise = getFiscalYears();
  const granteesPromise = getGrantees();
  const userPromise = getUserInfo();
  const categoriesPromise = getFieldCategories();
  Promise.all([granteesPromise, userPromise, yearsPromise, categoriesPromise])
    .then((values) => {

      //check for querystring parameters and get data if passed
      //note that this method hides the spinner when it is done
      baseComponent.state.displayReportById();
    }
  );
}
waitForMount();
